/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */
const VClickOutside = {
  bind(el: any, binding: any, vnode: any): void {
    // eslint-disable-next-line no-param-reassign
    el.clickOutsideEvent = (event: Event) => {
      // here I check that click was outside the el and his children
      if (!event.composedPath().includes(el)) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    window.addEventListener('click', el.clickOutsideEvent);
    window.addEventListener('touchstart', el.clickOutsideEvent);
  },
  unbind(el: any): void {
    window.removeEventListener('click', el.clickOutsideEvent);
    window.removeEventListener('touchstart', el.clickOutsideEvent);
  },
};
/* eslint-enable @typescript-eslint/no-var-requires, @typescript-eslint/explicit-module-boundary-types */

export default VClickOutside;
